import React from "react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

const Article = ({ content, afterArticleCTA }) => {
  return (
    <div className="article">
      <div className="container text-[#2c6bb3]">
        <BlocksRenderer content={content} />
        {afterArticleCTA && (
          <div className="bg-white shadow rounded-xl border-t-[3px] border-sky-800 mt-10 px-5 py-4">
            <h5 className="!text-2xl font-bold mb-3">Did you know?</h5>
            <p>{afterArticleCTA}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Article;
